import Icon from 'veui/components/Icon'
import { IconSlidersSquare } from 'dls-icons-vue'

Icon.register('sliders-square', IconSlidersSquare)
